import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import 'react';
import { useUncontrolled } from '../../hooks/useUncontrolled.js';
import { RadioGroupContext } from './context/RadioGroup.context.js';
import { Radio } from './Radio.js';
import defaultStyles from './styles/Radio.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { isArray, isObject } from '../../utils/is.js';

const RadioGroup = props => {
  const {
    theme,
    name,
    children,
    direction = 'horizontal',
    disabled,
    type = 'radio',
    options,
    size = 'md',
    variant = 'default',
    validationStatus,
    value,
    defaultValue,
    onChange,
    dataTestId
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    fallbackValue: '',
    onChange
  });
  const radioGroupClassNames = clsx(styles.group, {
    [styles.group_button]: variant === 'button',
    [styles.vertical]: direction === 'vertical'
  });
  const onChangeValue = value => {
    setValue(value);
  };
  const contextProp = {
    onChangeValue,
    type,
    value: _value,
    disabled,
    group: true,
    name,
    size,
    variant
  };
  return /*#__PURE__*/jsx(RadioGroupContext.Provider, {
    value: contextProp,
    children: /*#__PURE__*/jsx("div", {
      className: radioGroupClassNames,
      "data-test-id": dataTestId,
      role: "radiogroup",
      children: options && isArray(options) ? options.map((option, index) => {
        if (isObject(option)) {
          return /*#__PURE__*/jsx(Radio, {
            title: option.label,
            validationStatus: validationStatus,
            disabled: disabled || option.disabled,
            value: option.value,
            name: option.label,
            label: option.label,
            "aria-label": option.label,
            theme: theme
          }, option.value);
        }
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          jsx(Radio, {
            validationStatus: validationStatus,
            value: option,
            label: option,
            disabled: disabled,
            name: option,
            "aria-label": option,
            theme: theme
          }, index)
        );
      }) : children
    })
  });
};

export { RadioGroup };
